// extracted by mini-css-extract-plugin
module.exports = {"updown":"Updown_updown__5pe7U","up":"Updown_up__Blcss","down":"Updown_down__PUAnw"};